import { Dispatch, SetStateAction } from 'react';

import PriceTargetsListItem from './PriceTargetListItem/PriceTargetsListItem';
import SortHeader from './SortHeader';

import { useSort } from '../../../hooks/useSort';

import { COLUMNS_TARGET_PRICE } from '../../../constants/lists';

import { IStrategy, IStrategyAsset } from '../../../types/model';

const PriceTargetsList = ({
  strategyAssets,
  currency,
  width,
  setAssetTargetDetails,
}: {
  strategyAssets: IStrategyAsset[];
  width: number;
  setAssetTargetDetails: Dispatch<SetStateAction<JSX.Element | undefined>>;
  currency: IStrategy['currency'];
}) => {
  let sortedStrategyAssets = [...strategyAssets];

  const { getSortValue, handleSort, type } = useSort(COLUMNS_TARGET_PRICE);

  if (type === 'ASSET') {
    sortedStrategyAssets = sortedStrategyAssets.sort((a, b) =>
      getSortValue(a.name, b.name)
    );
  } else if (type === 'ENTRY PRICE') {
    sortedStrategyAssets = sortedStrategyAssets.sort((a, b) =>
      getSortValue(a.entryPrice, b.entryPrice)
    );
  } else if (type === 'LAST PRICE') {
    sortedStrategyAssets = sortedStrategyAssets.sort((a, b) =>
      getSortValue(a.asset.history[0]?.usd, b.asset.history[0]?.usd)
    );
  }

  return (
    <>
      {width !== 1 && (
        <SortHeader
          className="grid grid-cols-5 bg-grey-5 dark:bg-grey-90 sticky top-0 z-20"
          columns={COLUMNS_TARGET_PRICE}
          handleSort={handleSort}
          type={type}
          width={width}
        />
      )}
      {sortedStrategyAssets.map((strategyAsset, i) => (
        <PriceTargetsListItem
          key={strategyAsset.id + i}
          strategyAsset={strategyAsset}
          width={width}
          currency={currency}
          setAssetTargetDetails={setAssetTargetDetails}
        />
      ))}
    </>
  );
};

export default PriceTargetsList;
